import isObject from 'lodash/isObject';

import { isNotEmptyString } from '@atlassian/ui-modifications-public-api-utils/is-not-empty-string';
export const validateSetOptionsVisibilityRule = (optionsVisibility: { isVisible: boolean; options: string[] }) =>
    isObject(optionsVisibility) &&
    typeof optionsVisibility.isVisible === 'boolean' &&
    Array.isArray(optionsVisibility.options) &&
    optionsVisibility.options.every(isNotEmptyString);
